import type { TGlobalConstants } from '@/types'
import { inject } from 'vue'
import type { RouteLocation } from 'vue-router'

/**
 * Checks if the current domain is a valid domain
 * for the app or is a (sub) domain from a partner.
 *
 * @param {RouteLocation} to
 * @param {RouteLocation} from
 */
export default function domainCheck(to: RouteLocation, from: RouteLocation) {
  const globalConstants = inject<TGlobalConstants>('globalConstants')

  if (
    globalConstants &&
    from.fullPath.includes('/campaign') &&
    !window.location.origin.includes(globalConstants.BASE_URL)
  ) {
    window.location.assign(`${globalConstants.BASE_URL}/${to.fullPath}`)
    return false
  }
}
